<template>
  <v-layout row wrap align-center>
    <v-flex xs12 md12>
      <div class="text-center pa-5">
        <h3>{{ title }}</h3>
        <v-flex>
          <div class="font-weight-light" style="height: 200px">
            <p>{{ subtitle }}</p>
            <!--            <img alt="empty mind" :src="icon" height="160">-->
            <lottie
              :options="defaultOptions"
              :height="160"
              :width="160"
              v-on:animCreated="handleAnimation"
            />
          </div>
          <div class="ma-2 pa-2" v-if="cta">
            <v-btn large color="primary" dark :to="{ name: cta.route }">{{
              cta.title
            }}</v-btn>
          </div>
        </v-flex>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import Lottie from "vue-lottie";
import * as animationData from "../../../../animations/629-empty-box";

export default {
  components: {
    lottie: Lottie,
  },
  name: "MessageCard",
  props: {
    title: { type: String },
    subtitle: { type: String },
    icon: { type: String },
    cta: { type: Object },
  },
  data() {
    return {
      defaultOptions: {
        animationData: animationData.default,
        loop: true,
        autoplay: true,
        rendererSettings: { preserveAspectRatio: "xMidYMid slice" },
      },
      animationSpeed: 1,
      anim: null,
    };
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
      console.log(anim);
    },
  },
};
</script>

<style scoped></style>
